// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1uYi3","btn":"Tabs_btn__-teTU","btnActive":"Tabs_btnActive__Y2bYf","tabContent":"Tabs_tabContent__3Sjwm"};